import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Plus } from 'lucide-react';
import { BoardCard } from './BoardCard';
import type { BoardTask, ColumnDef } from '../../lib/boardGrouping';

export function BoardColumn({ col, tasks, scopeColors, onQuickAdd, onOpenTask }: {
  col: ColumnDef; tasks: BoardTask[];
  scopeColors: Map<string, { name: string; color: string }>;
  onQuickAdd: (colKey: string) => void;
  onOpenTask: (taskId: string) => void;
}) {
  const { setNodeRef, isOver } = useDroppable({ id: col.key, data: { colKey: col.key } });
  return (
    <div className="w-[80vw] sm:w-[290px] flex-shrink-0 flex flex-col bg-bg-secondary border border-border rounded-xl max-h-full">
      <div className="flex items-center gap-2 px-3.5 py-3">
        <span className="w-2.5 h-2.5 rounded" style={{ background: col.color }} />
        <span className="text-sm font-semibold text-text-primary">{col.label}</span>
        {col.isNew && <span className="text-[9px] font-bold uppercase tracking-wide text-accent-hover bg-accent/20 rounded px-1.5">new</span>}
        <span className="ml-auto text-[11px] text-text-muted bg-bg-card rounded-full px-2 tabular-nums">{tasks.length}</span>
        <button onClick={() => onQuickAdd(col.key)} className="text-text-muted hover:text-text-primary" title="Add task here">
          <Plus size={15} />
        </button>
      </div>
      <div ref={setNodeRef}
        className={`flex-1 overflow-y-auto px-2.5 pb-2.5 flex flex-col gap-2 ${isOver ? 'bg-accent/5' : ''}`}>
        <SortableContext items={tasks.map(t => t.id)} strategy={verticalListSortingStrategy}>
          {tasks.length === 0
            ? <div className="text-xs text-text-muted text-center py-4 italic opacity-60">No tasks</div>
            : tasks.map(t => <BoardCard key={t.id} task={t} fromCol={col.key} scopeColors={scopeColors} onOpenTask={onOpenTask} />)}
        </SortableContext>
      </div>
    </div>
  );
}
